export default __webpack_public_path__ + "static/media/banner.3c5f3ab8.png";